import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	templateUrl: './signature-modal.html',
	selector: 'app-signature'
})
export class SignatureModalComponent implements OnInit {
	public imageSrc: any;

	constructor(public dialogRef: MatDialogRef<SignatureModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any) {

	}

	closeModal() {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.imageSrc = this.data.imageSrc;
	}
}
